import { SQLField, SQLInfo, SQLType } from "../../framework.core/data/SQLInfo";

export function saveAcctHistory(id:number, type:string, actionType:number):SQLInfo {
  return new SQLInfo({
    tableName: SQLInfo.SaveAcctHistory,
    type: SQLType.Execute,
    whereFields: [
      new SQLField({ fieldName: '', propertyName: 'id', value: id}),
      new SQLField({ fieldName: '', propertyName: 'type', value: type}),
      new SQLField({ fieldName: '', propertyName: 'actionType', value: actionType})
    ]
  });
}